<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose, defineProps, reactive, onMounted } from 'vue';
    import axios from 'axios';

    const props = defineProps({});
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: null as number | null,
        libelle: "",
        telephone: "",
        adresse: "",
        commune_id: "",
        is_default: false,
    });
    const errors = reactive({
        libelle: "",
        telephone: "",
        adresse: "",
        commune_id: "",
    });
    const communesByVille = reactive({} as { [key: string]: { id: number, nom_commune: string }[] });

    async function _getStartupFormInfos() {
        try {
            const httpResponse = await axios.get(`/market/checkout_form_infos`);
            const data = httpResponse.data;
            const lcommunesByVille: { [key: string]: { id: number, nom_commune: string }[] } = {};
            data.communes.forEach((commune: { id: number, nom_commune: string, ville: string }) => {
                if (!lcommunesByVille[commune.ville]) {
                    lcommunesByVille[commune.ville] = [];
                }
                lcommunesByVille[commune.ville].push(commune);
            });
            Object.assign(communesByVille, lcommunesByVille);
        } catch(error) {
            console.error("Erreur lors de la récupération des infos du formulaire d'adresse de livraison", error);
        }
    }

    async function open(item?: any) {
        await _getStartupFormInfos();
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        if (item) {
            formData.id = item.id;
            formData.libelle = item.libelle;
            formData.telephone = item.telephone;
            formData.adresse = item.adresse;
            formData.commune_id = item.commune_id;
            formData.is_default = item.is_default;
        } else {
            formData.id = null;
            formData.libelle = "";
            formData.telephone = "";
            formData.adresse = "";
            formData.commune_id = "";
            formData.is_default = false;
        }
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="Le libellé est requis";
            isValid = false;
        }

        errors.telephone = '';
        if (!formData.telephone) {
            errors.telephone ="Le téléphone est requis";
            isValid = false;
        }

        errors.adresse = '';
        if (!formData.adresse) {
            errors.adresse ="L'adresse est requise";
            isValid = false;
        }

        errors.commune_id = '';
        if (!formData.commune_id) {
            errors.commune_id ="La commune est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                libelle: formData.libelle,
                telephone: formData.telephone,
                adresse: formData.adresse,
                commune_id: formData.commune_id,
            };

            const httpResponse = await axios.post(`/market/save_user_adresse`, formToUpload);
            resolvePromise(httpResponse.data);
            isModalOpen.value = false;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" @closed="onClose">
        <template #header>
            <div style="flex: 1; display: flex; flex-direction:row; justify-content: space-between;">
                <h4 class="font-semibold">{{ formData.id ? 'Modifier une adresse de livraison' : 'Ajouter une adresse de livraison' }}</h4>
            </div>
        </template>
        <div>
            <div class="form-field-floating reactive my-4">
                <input type="text" class="form-input" v-model="formData.libelle" name="libelle" id="libelle" placeholder="" autocomplete="off">
                <label for="libelle">Nom de l'adresse <b class="color-danger">*</b></label>
            </div>
            <span v-if="!!errors['libelle']" class="text-red">{{ errors['libelle'] }}</span>

            <div class="form-field-floating my-5">
                <select class="form-input-select" name="commune_id" id="commune_id" v-model="formData.commune_id">
                    <option value="" selected>Sélectionnez Ville/Commune</option>
                    <optgroup :label="ville" v-for="(communes, ville, index) of communesByVille" :key="index">
                        <option v-for="(commune, subindex) of communes" :value="commune.id" :key="subindex">{{ commune.nom_commune }}</option>
                    </optgroup>
                    <option value="">Bouaké</option>
                </select>
                <label for="commune_id">Sélectionnez Ville/Commune <b class="color-danger">*</b></label>
            </div>
            <span v-if="!!errors['commune_id']" class="text-red">{{ errors['commune_id'] }}</span>

            <div class="form-field-floating reactive my-4">
                <input type="text" class="form-input" v-model="formData.adresse" name="adresse" id="adresse" placeholder="" autocomplete="off">
                <label for="adresse">Adresse complete <b class="color-danger">*</b></label>
            </div>
            <span v-if="!!errors['adresse']" class="text-red">{{ errors['adresse'] }}</span>

            <div class="form-field-floating reactive my-4">
                <input type="text" class="form-input" v-model="formData.telephone" name="telephone" id="telephone" placeholder="" autocomplete="off">
                <label for="telephone">Numero de téléphone <b class="color-danger">*</b></label>
            </div>
            <span v-if="!!errors['telephone']" class="text-red">{{ errors['telephone'] }}</span>

            <div class="card-check lg single">
                <label class="form-check-label">
                    <div class="card-check-text">
                        <input class="form-check-input left" type="checkbox" name="is_default" id="is_default" value="1" v-model="formData.is_default" />
                        <h6 class="font-semibold mt-1 mb-2 align-right">Adresse de livraison par défaut ?</h6>
                    </div>  
                </label>
            </div>
            <div class="clear-both"></div>
        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onSubmit">Valider</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Annuler</button>
        </template>
    </custom-modal>
</template>
